import { create } from 'zustand';

export interface Role {
	id: string;
	name: string;
	duration: string;
}

interface RolesState {
	roles: Role[];
	addRole: (role: Role) => void;
	updateRole: (id: string, role: Role) => void;
	deleteRole: (id: string) => void;
}

const useRolesStore = create<RolesState>(set => ({
	roles: [
		{ id: '1', name: 'Liner', duration: '2 hours' },
		{ id: '2', name: 'Picker', duration: '3 hours' },
		{ id: '3', name: 'Dropper', duration: '2.5 hours' },
		{ id: '4', name: 'Feeder', duration: '1.5 hours' },
		{ id: '5', name: 'Prepper', duration: '1 hour' },
		{ id: '6', name: 'Front', duration: '4 hours' },
		{ id: '7', name: 'Back', duration: '3.5 hours' },
		{ id: '8', name: 'Whole', duration: 'Full Day' },
	],

	addRole: role =>
		set(state => ({
			roles: [...state.roles, role],
		})),

	updateRole: (id, updatedRole) =>
		set(state => ({
			roles: state.roles.map(r => (r.id === id ? updatedRole : r)),
		})),

	deleteRole: id =>
		set(state => ({
			roles: state.roles.filter(r => r.id !== id),
		})),
}));

export default useRolesStore;
